module.exports = __webpack_public_path__ + "static/media/reach.9ccd228f.svg";